// actions
import {
  PLACES_SET_COORDS,
  PLACES_SET_ADDRESS,
  PLACES_REVERSE_ORDER,
  PLACES_VALIDATE_TRIP,
  PLACES_CLEAR,
  PLACES_TOGGLE_EDIT,
  PLACES_RESTORE,
  PLACES_SET_FOCUSED,
  PLACES_ADD_FIELD,
  PLACES_REMOVE_FIELD,
  PLACES_REORDER_FIELDS,
  PLACES_UPDATE_LENGTH,
  updatePlacesCoords,
  updatePlacesAddress,
  swapPlaces,
  updatePlacesValidity,
  removePlaces,
  hydratePlaces,
  addField,
  removeField,
  reorderFields,
} from './actions';

const Places = (
  state = {
    fields: [],
    tripIsValid: false,
    numberOfStopoversSingular: '{TOTAL} stop',
    numberOfStopoversPlural: '{TOTAL} stops',
    editing: true,
    focused: '',
    fieldsLength: 2,
  },
  action,
) => {
  switch (action.type) {
    case PLACES_SET_COORDS:
      return {
        ...state,
        fields: updatePlacesCoords(state, action),
      };
    case PLACES_SET_ADDRESS:
      return {
        ...state,
        fields: updatePlacesAddress(state, action),
      };
    case PLACES_REVERSE_ORDER:
      return {
        ...state,
        fields: swapPlaces(state, action),
      };
    case PLACES_VALIDATE_TRIP:
      return {
        ...state,
        tripIsValid: updatePlacesValidity(state),
      };
    case PLACES_CLEAR:
      return {
        ...state,
        fields: removePlaces(state),
        tripIsValid: false,
        fieldsLength: 2,
      };
    case PLACES_TOGGLE_EDIT:
      return {
        ...state,
        editing: action.editing,
      };
    case PLACES_RESTORE:
      return {
        ...state,
        ...hydratePlaces(state, action),
      };
    case PLACES_SET_FOCUSED:
      return {
        ...state,
        focused: action.focused,
      };
    case PLACES_ADD_FIELD:
      return {
        ...state,
        fields: addField(state),
        fieldsLength: state.fields.length + 1,
      };
    case PLACES_REMOVE_FIELD:
      return {
        ...state,
        fields: removeField(state, action),
        fieldsLength: state.fields.length - 1,
      };
    case PLACES_REORDER_FIELDS:
      return {
        ...state,
        fields: reorderFields(state, action),
      };
    case PLACES_UPDATE_LENGTH:
      return {
        ...state,
        fieldsLength: state.fields.length,
      };
    default:
      return state;
  }
};

export default Places;
